import { getCdnImageSrc, HStack, Image, responsive } from "goi_common";

const ProductPaymentProcessImage = ({ imgSrc }: { imgSrc?: string }) => {
  return (
    <HStack
      justifyContent="center"
      alignItems="center"
      borderRadius="20px"
      css={responsive({
        margin: { base: "0 0 40px", md: "0 0 40px" },
        padding: "10px 0px",
      })}
    >
      <Image
        src={getCdnImageSrc(
          imgSrc || "direct/registration/payment-progress-without-price.png"
        )}
        css={{
          width: "100%",
        }}
        alt={"payment-progress"}
      />
    </HStack>
  );
};

export default ProductPaymentProcessImage;
